// The product's name and the assistant's default name, as the server renders
// them into <meta> tags in the layouts (Brand::APP_NAME, "Lex" on lex.legal.io,
// and UserSetting::DEFAULT_ASSISTANT_NAME). The fallbacks are only for a page
// that has no tag; taskjane.com renders "Jane" for both.
function meta(name, fallback) {
    const el = document.querySelector(`meta[name="${name}"]`)
    return (el && el.content) || fallback
}

export const brandName = () => meta("app-brand", "Jane")
export const titleSuffix = () => meta("app-title-suffix", brandName())
export const defaultAssistantName = () => meta("app-default-assistant", "Jane")
